export default {
  data () {
    return {};
  },
  methods: {
    endTime () {
      return {
        rules: [
          {required: true, message: '请选择截止时间'},
          {pattern: /^\d{1,5}$/, message: '请输入整数数字'},
          {validator: this.validateEndTime}
        ]
      };
    },
    /** 验证截止时间 */
    validateEndTime (rules, value, callback) {
      value = parseInt(value);
      if (value <= 0) {
        callback(new Error('截止时间需大于0'));
      } else if (value > 43200) {
        callback(new Error('截止时间不大于43200'));
      } else {
        callback();
      }
    }
  }
};
